import React from 'react';
import { useLifeStore } from './hooks/useLifeStore';
import { useTheme, type ThemePreference } from './hooks/useTheme';
import { Onboarding } from './components/Onboarding';
import { LifeCalendar } from './components/LifeCalendar';
import type { LifetimeStyle } from './components/views/LifetimeView';
import type { ViewMode } from './types/life';
interface AppProps {
  /** Which view the calendar opens on */
  initialView?: 'now' | 'life';
  /** How "Whole life" encodes the past: faded — lived weeks greyed out, struck — lived weeks black and crossed out */
  lifetimeStyle?: 'faded' | 'struck';
  /** Theme: system follows the OS setting */
  theme?: 'system' | 'light' | 'dark';
}
export function App({
  initialView = 'now',
  lifetimeStyle = 'faded',
  theme = 'system'
}: AppProps) {
  const {
    profile,
    milestones,
    saveProfile,
    upsertMilestone,
    removeMilestone
  } = useLifeStore();
  const themeState = useTheme(theme as ThemePreference);
  return <div data-theme={themeState.resolved} className="bg-paper text-ink h-[100dvh] min-h-full w-full font-sans" data-id="element-0" data-mp="23v2sz2h3ez4v">
      {profile ? <LifeCalendar profile={profile} milestones={milestones} initialView={initialView as ViewMode} lifetimeStyle={lifetimeStyle as LifetimeStyle} theme={themeState} onSaveProfile={saveProfile} onUpsertMilestone={upsertMilestone} onRemoveMilestone={removeMilestone} data-id="element-1" data-mp="3ml12h5fg3ihf" /> : <Onboarding onSubmit={saveProfile} data-id="element-2" data-mp="2zng1wlgyumtg" />}
    </div>;
}